'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
// import TechnologyFaq from "@/components/technologies/technology-faq"
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import IphoneappServices from '@/components/technologies/iphoneapp-services';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
// import IphoneappFAQ from "@/components/faqs/iphoneapp-faq"
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="We Believe in Delivering Top-notch iPhone App Development Services for Fortune Clients Across the Globe."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'iphone-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                iPhone App Development
            </TechHeroApp>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="iPhone App Development" />

            <ContetVideoSection title="Cutting-edge iPhone App Development Company Across the Globe">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Having delivered a wide array of smart, secure and scalable iPhone application development services
                        globally, we have become the premium pick of 500+ clients overseas for all sorts of custom iPhone
                        application development. Renowned as the best iPhone app development companies in delivering end-to-end
                        and tailored solutions using the latest iOS SDK, we excel in deploying quality mobile solutions to an
                        array of segments and industries.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        We do everything right from the conceptualization, ideation till deployment. We just don’t build apps; we
                        build your concepts backed by the latest technology and innovation to be competitive in the industry. The
                        work experience of our professional and certified developers with cutting-edge tools and technologies to
                        deliver exceptional solutions is what makes us ever demanding in the market.
                    </p>
                </>
            </ContetVideoSection>
            <IphoneappServices title="Serving in Multiple Segments, Our Core Services Include:"></IphoneappServices>
            <HireProcess
                bg="bg-iphoneapp"
                pageTitle="Hire Custom iPhone Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using iPhone."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for iPhone Development? " />
            <ModelsOfWorking
                title="Engagement models to hire the best iPhone Developers"
                desc="Select from different engagement models to hire iPhone Developers for your business needs. Different types of engagements allow you to find an optimal match for your company's specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />

            {/* <TechnologyFaq title="FAQs On iPhone Development" bg="bg-iphoneapp">
        <IphoneappFAQ />
      </TechnologyFaq> */}
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
